import React from 'react';

import {
  PersonalisationListItem,
  PersonaliseInfo,
  SelectionEdit,
} from '../styles';
import PersonalisationInput from './PersonalisationInput';
import PresetMessages from './common/PresetMessages';
import SingleMsgPrompt from './common/SingleMsgPrompt';

const SelectionPersonalise = ({
  selection,
  limit,
  currentRange,
  handleAddMessage,
  firstMsg,
  setFirstMsg,
  handleSingleMessage,
  singleMessage,
  setSingleMessage,
  clearMultiMessage,
  presetMsg,
  setPresetMsg,
  isMobile,
  getCharacterCount,
}) => {


  return (
    <div className="scroll-inner">
      <PersonaliseInfo>
        <span>
          {
            selection.filter((item) => item.personalisation_available === 'Y')
              .length
          }
        </span>
        <span>/{limit}</span> cupcakes can be personalised
      </PersonaliseInfo>
      {currentRange.bundle_name === 'REG_OBJ' && (
        <PresetMessages
          presetMsg={presetMsg}
          setPresetMsg={setPresetMsg}
          handleSingleMessage={handleSingleMessage}
        />
      )}
      <div>
        {selection
          .filter((item) => item.personalisation_available === 'Y')
          .map((selectionItem, i) => (
            <PersonalisationListItem key={selectionItem.bId}>
              <div className="personalisation-item__img-container">
                <img
                  src={selectionItem.img}
                  alt={`${selectionItem.title} personalisation list image`}
                />
              </div>
              <span>
                {i + 1}. {selectionItem.title}
              </span>
              <div className="personalisation-item__input-container">
                <PersonalisationInput
                  isMobile={isMobile}
                  item={selectionItem}
                  handleAddMessage={handleAddMessage}
                  firstMsg={firstMsg}
                  setFirstMsg={setFirstMsg}
                  singleMessage={singleMessage}
                  handleSingleMessage={handleSingleMessage}
                  setSingleMessage={setSingleMessage}
                  presetMsg={presetMsg}
                  setPresetMsg={setPresetMsg}
                  selection={selection}
                  getCharacterCount={getCharacterCount}
                />
              </div>
              {firstMsg === selectionItem.bId && (
                <SingleMsgPrompt
                  singleMessage={singleMessage}
                  setSingleMessage={setSingleMessage}
                  handleSingleMessage={handleSingleMessage}
                  selection={selection}
                  firstMsg={firstMsg}
                  isMobile={isMobile}
                />
              )}
            </PersonalisationListItem>
          ))}
      </div>
      <div className="mb-3">
        <SelectionEdit onClick={() => clearMultiMessage()}>
          clear all messages
        </SelectionEdit>
      </div>
    </div>
  );
};

export default SelectionPersonalise;
